import React from 'react'
import { useEffect, useState } from "react";
import HeaderMenuContent from './HeaderMenuContent';
import YoloWhite from '../../assets/svgs/Yolo_White_Img.svg'
import YoloPink from '../../assets/svgs/Yolo_Rosa_Img.svg'


const Header = () => {
    const [navbar, setNavbar] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 95) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);
  }, []);

  return (
    <header
      className={`header-nav menu_style_home_one navbar-scrolltofixed stricky main-menu  ${
        navbar ? "stricky-fixed " : ""
      }`}
    >
      <div className="container-fluid p0">
        {/* <!-- Ace Responsive Menu --> */}

        <a href="https://www.yolocoliving.com.br/" target='' className="navbar_brand float-start dn-smd">
          <img style={{width:'170px',height:'84.5px'}}
            className="logo1 contain"
            src={YoloWhite}
            alt="header-logo.png"
          />
          <img style={{width:'158px',height:'110px'}}
            className="logo2 contain"
            src={YoloPink}
            alt="header-logo2.png"
          />
        </a>
        {/* site logo brand */}

        <nav>
          <HeaderMenuContent />
        </nav>
        {/* End .navbar */}
      </div>
    </header>
    // {/* <!-- /.theme-main-menu --> */}
  );
}

export default Header
